import React from 'react';
import { Link } from 'react-router-dom'
import Prismic from 'prismic-javascript'
import { apiEndpoint, accessToken, linkResolver } from 'prismic-config';

export const client = Prismic.client(apiEndpoint, { accessToken })
